import React, { useState, useContext, useEffect } from 'react';
import UserContext from '../../context/Globales/UserContext';
import { makeStyles, TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Button, Grid, Modal, Fade, Backdrop, Typography, Divider } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import swal from 'sweetalert';
import TblExtractoSociedad from './TblExtractoSociedad';
import ViewInformeModal from '../ConsultaInformeModal/ViewInformeModal';
import Loading from '../modales/Loading';
import IcpdfDetallesSociedades from '../pdf/IC/IcpdfDetallesSociedades';
import { globales, mensajeglobales } from '../../helpers/Confi';
import { DecodificanString } from '../../helpers/Codifican';
const useStyles = makeStyles((theme) => ({
  tituloTable: {

    backgroundColor: '#e6e6e6',
    minWidth: 200,
    color: 'black',
    textAlign: 'center',
    padding: '10px',
    fontWeight: '250',
    fontSize: '16px'
  },
  tituloTable2: {

    backgroundColor: theme.palette.fondotitulos.main,
    // backgroundImage : `url(${FondoImagenes})`,

    minWidth: 200,
    color: '#171717',
    textAlign: 'center',
    padding: '16px',
    fontWeight: '250',
    fontSize: '35px'
  },

  TituloIdentificacion: {

    backgroundColor: theme.palette.primary.main,
    minWidth: 200,
    color: 'white',
    textAlign: 'center',
    padding: '15px',
    fontWeight: '250',
    fontSize: '18px',
    height: 'auto',
    alignContent: 'center',
  },
  modaldetalle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'scroll',
    height: '100%',
  },
  paperdetalle: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '50%',
    height: '50%',
    overflow: 'scroll',
  },

  modalExtracto: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'scroll',
    height: '100%',
  },
  paperExtracto: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '50%',
    height: '50%',
    overflow: 'scroll',
  },

  paperInforme: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '95%',
    height: '90vh',
    overflow: 'scroll',
  },

  modalInforme: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'scroll',
    height: '100%',
  },


  modalPdf: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  paperPdf: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '50%',
  },
  FondoTable: {

    backgroundColor: theme.palette.greyFondo.main
  },

  containerTable: {
    maxHeight: 440,
    maxWidth: '100%'
  },
  mousePointer: { cursor: 'pointer' },
}));

const TblDetalleSociedades = (dataSociedades) => {
  const classes = useStyles();

  const DatosTipoContrato = DecodificanString(localStorage.getItem("tipCont"))

  const [datoSO] = React.useState(dataSociedades)
  const [OpenModalExtracto, setOpenModalExtracto] = React.useState(false);
  const [OpenModalIC, setOpenModalIC] = React.useState(false);
  const [OpenLoadingIC, setOpenLoadingIC] = React.useState(false)
  const [OpenModalPdfSociedades, setOpenModalPdfSociedades] = React.useState(false);

  const userContext = useContext(UserContext);
  const { DataContatoInfoCom, datoIC, DatadetalleExtracto } = useContext(UserContext);
  const parametros = globales();  //  parametros globales:
  const MSG = mensajeglobales(); // mensaje globales;

 // console.log(datoSO);
  //  console.log(dataSociedades);
  const OpenModalPdfSocie = () => {

    setOpenModalPdfSociedades(!OpenModalPdfSociedades);
  }


  const handleClickSocieExtracto = () => {
    setOpenModalExtracto(false);

  };

  const handleClickInformeModal = () => {
    setOpenModalIC(!OpenModalIC);
  }

  const MostrarExtracto = (Extracto) => {
    
    if (DatadetalleExtracto == null || DatadetalleExtracto == 'ERROR CONSULTA EXTRACTO' ){
      userContext.getDetalleExtracto(Extracto, datoIC.ID);
      //handleClickSocieExtracto();
      setOpenModalExtracto(true)
    }else{
      setOpenModalExtracto(true)
    }
   
  };




  const ConsultaSocioIC = (Rut) => {
    setOpenLoadingIC(true);

    const id = DecodificanString(JSON.parse(localStorage.getItem("id")));
    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const clientId = DecodificanString(JSON.parse(localStorage.getItem("clientId").toString()));  

    userContext.getContractInfoCom(id, login, clientId, DatosTipoContrato.Id);//obten los datos que solicite en el formulario

    //validacion


    if (DataContatoInfoCom.Exist || DecodificanString(JSON.parse(localStorage.getItem('ContratoInfoCom')))) {



      setTimeout(() => {
        userContext.getInfoComercialModal(Rut);
        handleClickInformeModal();
        setOpenLoadingIC(false);
      }, 3000);

    } else {

      setOpenLoadingIC(false);

      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "OK",
      });
    }

  };


  return (
    <>
      {OpenLoadingIC ? <Loading /> : ''}




      {/*MODAL PDF INFORME COMER*/}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modalPdf}
        open={OpenModalPdfSociedades}
        onClose={OpenModalPdfSocie}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}>
        <Fade in={OpenModalPdfSociedades}>

          <div className={classes.paperPdf}>


            <IcpdfDetallesSociedades dato={datoSO} />



          </div>

        </Fade>
      </Modal>




      {/*Extracto */}


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modaldetalle}
        open={OpenModalExtracto}
        onClose={handleClickSocieExtracto}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}
      >
        <Fade in={OpenModalExtracto}>
          <div className={classes.paperdetalle}>


            <Typography variant="h5" align="right" onClick={handleClickSocieExtracto} className={classes.mousePointer} >X</Typography>

            <TblExtractoSociedad />

          </div>
        </Fade>
      </Modal>

      {/*InformeComercial Modal */}


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modalInforme}
        open={OpenModalIC}
        onClose={handleClickInformeModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}
      >
        <Fade in={OpenModalIC}>
          <div className={classes.paperInforme}>


            <Typography variant="h5" align="right" onClick={handleClickInformeModal} className={classes.mousePointer} >X</Typography>

            <ViewInformeModal />

          </div>
        </Fade>
      </Modal>


      <br />
      { datoSO && datoSO.dataSociedades != null ? <div style={{ alignContent: "center", textAlign: "center" }}><Button variant="contained" color="primary" onClick={OpenModalPdfSocie}>Descargar PDF</Button></div> : ''}
      <br />

      <div className={classes.content}>
        <h1 style={{ position: '-webkit-sticky', position: 'sticky', textAlign: 'center' }}>{datoSO.dataSociedades.NombreRazonSocialPublicada} </h1>
        <TableContainer className={classes.containerTable}>
          <Table>
            <TableBody >
              <TableRow>
                <TableCell colSpan="4" className={classes.tituloTable2} ></TableCell>
              </TableRow>
              <TableRow key={uuid()} style={{ backgroundColor: '#dedfe3' }}>

                <TableCell ><strong>Tipo Publicación:</strong></TableCell><TableCell>{datoSO.dataSociedades.TipoPublicacion}</TableCell>
                <TableCell><strong>Fecha de Públicación:</strong></TableCell><TableCell>{datoSO.dataSociedades.FechaPublicacion}</TableCell>

              </TableRow>
            </TableBody>

          </Table>
        </TableContainer>

        {datoSO.dataSociedades.Detalles.map((data, iddetalles) => (
          <TableContainer className={classes.containerTable}>
            <Table size="small">
              <TableBody key={iddetalles}>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }} ><strong>Rut:</strong></TableCell><TableCell>{data.Rut}   &nbsp; 
                  { data.Rut == null || data.Rut == '0-0' ?
                   'Imposible en rescatar este parametro' :  <Button variant="outlined" color="primary" onClick={() => { ConsultaSocioIC(data.Rut) }}>Informe Comercial</Button> }
                  </TableCell>

                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha de Escritura:</strong></TableCell><TableCell>{data.FechaEscritura}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha de Constitución:</strong></TableCell><TableCell>{data.FechaDeConstitucion}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha de Constitución:</strong></TableCell><TableCell>{data.FechaDeConstitucion}</TableCell>
                </TableRow>


                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Nombre de Fantasia:</strong></TableCell><TableCell>{data.NombreDeFantasia}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Constituidad como:</strong></TableCell><TableCell>{data.ConstituidaComo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Fecha de Termino:</strong></TableCell><TableCell>{data.FechaDeTermino}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Capital Suscrito (peso):</strong></TableCell><TableCell>{data.CapitalSuscrito}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Capital Pagado (peso):</strong></TableCell><TableCell>{data.CapitalPagado}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Acciones:</strong></TableCell><TableCell>{data.NumeroDeAcciones}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Localidad Registro Comercio:</strong></TableCell><TableCell>{data.CiudadNotario}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Extracto Público:</strong></TableCell><TableCell>{datoSO.dataSociedades.Extracto}
                  { data.Rut == null || data.Rut == '0-0' ? 
                  ' ' : <Button variant="outlined" color="primary" onClick={() => { MostrarExtracto(datoSO.dataSociedades.Extracto) }}>Ver Extracto</Button> }
                  </TableCell>
                </TableRow>
              </TableBody>

            </Table>
          </TableContainer>

        ))}


        {datoSO && datoSO.dataSociedades.Detalles[0].Socios != null ?



          <TableContainer className={classes.containerTable} hidden={datoSO.dataSociedades.Detalles[0].Socios == null || datoSO.dataSociedades.Detalles[0].Socios == undefined ? true : false} >
            <h1 style={{ position: '-webkit-sticky', position: 'sticky', textAlign: 'center' }}>LISTADO DE SOCIOS</h1>

            <Table size="small">
              <TableHead>
                <TableRow>

                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Rut:</strong></TableCell>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Nombre:</strong></TableCell>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Motivo:</strong></TableCell>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Aporte:</strong></TableCell>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Moneda:</strong></TableCell>
                  <TableCell style={{ backgroundColor: '#dedfe3' }}><strong>Porcentaje:</strong></TableCell>

                </TableRow>
              </TableHead>

              <TableBody  >
                {datoSO.dataSociedades.Detalles[0].Socios.map((Socios, idsociosdetalle) => (
                  <TableRow key={idsociosdetalle}>
                    <TableCell>{Socios.Rut}  &nbsp;
                    { Socios.Rut == null || Socios.Rut == '0-0' ? '' : 
                    <Button variant="outlined" color="primary" onClick={() => { ConsultaSocioIC(Socios.Rut) }}> Informe Comercial </Button>} </TableCell>
                    <TableCell>{Socios.Nombre}</TableCell>
                    <TableCell>{Socios.MotivoPublicacion}</TableCell>
                    <TableCell>{Socios.Aporte}</TableCell>
                    <TableCell>{Socios.Moneda}</TableCell>
                    <TableCell>{Socios.Porcentaje} %</TableCell>
                  </TableRow>
                ))}
              </TableBody>


            </Table>
          </TableContainer>
          : <h2>SIN INFORMACION DE SOCIOS</h2>

        }


      </div>







    </>
  )
}

export default TblDetalleSociedades;
